import { IFileSettings } from 'legacy/lut/library/dragNDrop'

import { saveFile } from 'core/classes/helpers/saveFiles'

import { QBR_ATTACHMENTS_DATA_SOURCE } from '../components/attachmentsTable/configs'
import { getJbpQbrAttachments } from '../helpers/getJbpQbrAttachments'

interface IUploadQbrAttachmentParameters {
  filesInfo: IFileSettings[]
  documentId: number
}

export const uploadQbrAttachment = async ({
  filesInfo,
  documentId,
}: IUploadQbrAttachmentParameters) => {
  const crud = getJbpQbrAttachments()
  const uploadFilesInfo = filesInfo.map((it) => {
    return {
      file: it.file,
      DocumentId: documentId,
    }
  })

  await saveFile({
    formId: +QBR_ATTACHMENTS_DATA_SOURCE.formId,
    formCode: QBR_ATTACHMENTS_DATA_SOURCE.code,
    fieldName: 'Name',
    models: uploadFilesInfo,
    source: crud,
  })
}
